export const GET_SHIPPING_METHOD = "GET_SHIPPING_METHOD";
export const CREATE_SHIPPING_METHOD = "CREATE_SHIPPING_METHOD";
export const UPDATE_SHIPPING_METHOD = "UPDATE_SHIPPING_METHOD";
export const DELETE_SHIPPING_METHOD = "DELETE_SHIPPING_METHOD";
